export const grade = () : number => {
    return Math.floor(
        Math.random() * 12 
    ) + 1 // min number 1, max number 12
}